"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrdenacaoDirecao = void 0;
var OrdenacaoDirecao;
(function (OrdenacaoDirecao) {
    OrdenacaoDirecao["ASC"] = "asc";
    OrdenacaoDirecao["DESC"] = "desc";
})(OrdenacaoDirecao || (exports.OrdenacaoDirecao = OrdenacaoDirecao = {}));
